import {Grid, makeStyles, Typography} from "@material-ui/core";
import { BounceLoader } from "react-spinners";
  const useStyles = makeStyles((theme) => ({
    root: {
      height: "100vh",
      display:"flex",
      flexDirection:"column",
      alignItems:"center",
      justifyContent:"center",
    },
  }));
  
  const LoadingScreen = () => {
    const classes = useStyles();
    return (
      <Grid container className={classes.root}>
            <BounceLoader color="orange"/>
            <Typography variant="h4" component="h2" style={{marginTop:"12px"}}>Cargando</Typography>
      </Grid>
    );
  };
  export default LoadingScreen;
  